import { render, staticRenderFns } from "./UploadFileItem.vue?vue&type=template&id=ff73c25a&scoped=true"
import script from "./UploadFileItem.vue?vue&type=script&lang=js"
export * from "./UploadFileItem.vue?vue&type=script&lang=js"
import style0 from "./UploadFileItem.vue?vue&type=style&index=0&id=ff73c25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff73c25a",
  null
  
)

export default component.exports